import {Typography} from '~library/atoms/Typography';

export const FilledVolunteerDetail = ({icon, label, text}) =>
  text?.trim()?.length > 0 && (
    <div className="filled-slot__item__detail">
      {icon && icon}
      <Typography
        variant="list1"
        color="pebble"
        data-qa-id={`signup-row-${label}`}
        data-qa-value={text}
      >
        {text}
      </Typography>
    </div>
  );
